export const config = {
  rowSelection: true,
  rowSelectionType: 'radio',
  columns: [
    {
      title: '员工姓名',
      key: 'userName',
      dataIndex: 'userName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '员工工号',
      key: 'loginAccount',
      dataIndex: 'loginAccount',
      width: 120,
    },
    {
      title: '所属组织',
      key: 'org',
      dataIndex: 'orgNamePath',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '职位',
      key: 'roleName',
      dataIndex: 'roleName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
  ],
  search: [
    {
      name: 'userName',
      label: '员工姓名',
    },
    {
      name: 'roleId',
      label: '角色',
      itemType: 'select',
      data: 'roleList',
      labelKey: 'name',
      key: 'id'
    },
  ],
}
